import { Component, input } from '@angular/core';
import { MatIcon } from '@angular/material/icon';
import { MatTooltip } from '@angular/material/tooltip';
@Component({
  selector: 'vectronic-header-group',
  templateUrl: './header-group.component.html',
  styleUrls: ['./header-group.component.scss'],
  imports: [MatIcon, MatTooltip],
})
export class HeaderGroupComponent {
  title = input<string>();
  icon = input<string>();
  headerTooltip = input<string>();
}
